import React, { useState, useEffect, useRef } from "react";
import './MyAssessmentTooltip.scss';

const MyAssessmentTooltip = ({ target, text = '', title = '', description = ''}) => {
    const [isVisible, setIsVisible] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const tooltipRef = useRef(null);

    useEffect(() => {
        const element = document.getElementById(target);
        if (!element) return;

        const handleMouseEnter = (e) => {
            const rect = element.getBoundingClientRect();
            setPosition({
                top: rect.top - 40, // Position above the element
                left: rect.left + rect.width / 2
            });
            setIsVisible(true);
        };

        const handleMouseLeave = () => {
            setIsVisible(false);
        };

        element.addEventListener('mouseenter', handleMouseEnter);
        element.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            element.removeEventListener('mouseenter', handleMouseEnter);
            element.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [target]);

    // Only show tooltip if there's content to display
    const hasContent = text || title || description;
    if (!hasContent) return null;

    return (
        <>
            {isVisible && (
                <div
                    ref={tooltipRef}
                    className="my-assessment-tooltip"
                    style={{
                        position: 'fixed',
                        top: `${position.top}px`,
                        left: `${position.left}px`,
                        transform: 'translateX(-50%)',
                        zIndex: 1000,
                        display: isVisible ? 'block' : 'none'
                    }}
                >
                    {text !== '' ? <span className="my-assessment-tooltip__text">{text}</span> : null}
                    {title !== '' ? <strong className="my-assessment-tooltip__title">{title}</strong> : null}
                    {description !== '' ? <><br/>{description}</> : null}
                </div>
            )}
        </>
    );
}

export default MyAssessmentTooltip;